import { render, staticRenderFns } from "./CopyrightAmendmentApplication.vue?vue&type=template&id=121a12b6&scoped=true&"
import script from "./CopyrightAmendmentApplication.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentApplication.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentApplication.vue?vue&type=style&index=0&id=121a12b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121a12b6",
  null
  
)

export default component.exports